const css = `@media print{._1RCTDG__starIcon,._1RCTDG__moreMenuContainer,._1RCTDG__noPrint{display:none}._1RCTDG__flexFullWidth{flex-grow:1;overflow:visible}._1RCTDG__flexFullWidth *{white-space:initial}._1RCTDG__title *{display:inherit;visibility:visible;filter:opacity();padding-left:1px}}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"moreMenuContainer":"_1RCTDG__moreMenuContainer","title":"_1RCTDG__title","flexFullWidth":"_1RCTDG__flexFullWidth","noPrint":"_1RCTDG__noPrint","starIcon":"_1RCTDG__starIcon"};
